import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import FixedView from '../../components/FixedView'
import IntractionActionsList from '../../components/IntractionActionsList'
import importedIcons from '../../components/inputs/icons'
import HttpServices from '../../utils/Http.services'
import CustomLoader from '../../components/CustomLoader'

export default class DriveNew extends Component {

    state = {}

    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.newView.hideView()
    }

    openSelectAppletModal = (data, func) => {
        if (this.props.currentApplet == '' && !this.props.applet) {
            this.newView.hideView()
            this.props.setData(data, true, 'FileManager', () => {
                if (this.props.openSelectAppletModal) {
                    this.props.openSelectAppletModal()
                }
            })
        }
        else {
            // console.log('*functionsHandler*',func)
            this.functionsHandler(null, func)
        }
    }
    createDoc = (data) => {

        if (!this.props.applet && this.props.openSelectAppletModal) {

            this.props.openSelectAppletModal()

        } else {

            this.setState({ isLoadingCreateDoc: true })

            this.props.createDoc((res, err) => {

                this.setState({ isLoadingCreateDoc: false })

                if (!err) {
                    this.newView.hideView()
                }
            })
        }
        // if (this.props.currentApplet == '' && !this.props.applet) {
        // this.props.setData(data, true, 'FileManager', () => {
        // if (this.props.openSelectAppletModal) {
        this.props.openSelectAppletModal()
        // }
        // })
        // }
        // else {
        //     this.props.changePage('editor')
        // }
    }


    closeFixedView = () => {
        this.newView.hideView()
    }

    render() {
        return (
            <>

                <button className='mrd-2  p-0' ref={el => this.new = el} onClick={() => { this.newView.showView() }}>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-hover'>
                        {/* <div className='flexcc mrd-1'>
                            <img className={!this.props.colors.iconInvert ? 'invert' : ''} width={18} src="/assets/icons/imports/plus.svg" />
                        </div> */}
                        <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('drives.New')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.newView = el} nodeRef={this.new} xOffset={this.props.language == 'fa' ? 205 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <div className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                            <div className=''>
                                <IntractionActionsList onClick={() => (this.closeFixedView(), this.openSelectAppletModal('newFolder', 'folderModal'))} data={{
                                    title: "{{lang}}New Folder",
                                    // shortcut: 'Ctrl+Z',
                                    icon: importedIcons.folderPlus
                                }} />
                                <IntractionActionsList onClick={() => (this.closeFixedView(), this.openSelectAppletModal('newUpload', 'uploadModal'))} data={{
                                    title: "{{lang}}Upload files",
                                    // shortcut: 'Ctrl+Z',
                                    icon: importedIcons.upload
                                }} />
                                <IntractionActionsList onClick={() => (this.createDoc())} data={{
                                    title: "{{lang}}Blank document",
                                    // shortcut: 'Ctrl+Z',
                                    icon: importedIcons.upload
                                }} />

                                <IntractionActionsList onClick={() => { }} data={{
                                    title: "{{lang}}Document from template",
                                    // shortcut: 'Ctrl+Z',
                                    icon: importedIcons.upload
                                }} />
                                {/* <IntractionActionsList onClick={() => (this.closeFixedView(), this.props.openTemplatesModal())} data={{ title: "{{lang}}drives.Template", shortcut: 'Ctrl+Z', icon: importedIcons.upload }} /> */}
                                {/* <IntractionActionsList data={{ title: "{{lang}}drives.Shortcut", shortcut: 'Ctrl+Y', icon: importedIcons.shortcut }} /> */}
                                {/* <IntractionActionsList data={{ title: "{{lang}}drives.WinRAR ZIP archive", shortcut: 'Ctrl+Y', icon: importedIcons.winrarZip }} /> */}
                                {/* <IntractionActionsList data={{ title: "{{lang}}drives.WinRAR archive", shortcut: 'Ctrl+Y', icon: importedIcons.archive }} /> */}
                            </div>
                        </div>

                        {this.state.isLoadingCreateDoc && (
                            <div className="py-4 d-flex h-100 w-100 flexcc position-absolute top-0 left-0 br-10" style={{ backgroundColor: '#00000050' }}>
                                <CustomLoader isLoading={true} />
                            </div>
                        )}
                    </div>
                </FixedView>
            </>
        )
    }
}
